import {gql} from "@apollo/client";
import messageFragment from "../fragments/messageFragment";

export function optimisticResponse({created, text, chatGroupId, sender, richContent}) {
    const newRichContent = !richContent
        ? null
        : {
              reply: {
                  ...richContent.reply,
                  originalMessageText: richContent.reply.messageText || "",
                  isSenderBlocked: false,
                  __typename: "ReplyOutputField",
              },
              __typename: "RichContentOutputField",
          };
    return {
        __typename: "Mutation",
        sendMessage: {
            __typename: "SendMessageMutation",
            message: {
                __typename: "MessageField",
                id: `optimistic-${created}`,
                created,
                text,
                sender: {
                    __typename: "AnyUserField",
                    id: sender.id,
                    firstName: sender.firstName,
                    accountRole: sender.accountRole,
                    // we are the sender of this message so these fields are not required
                    profilePhoto: "",
                    degree: null,
                    country: null,
                    university: null,
                },
                richContent: newRichContent,
                chatGroupId,
                visible: "",
                read: null,
                attachment: null,
                deleted: null,
                isSenderBlocked: null,
                likes: [],
            },
            botMessages: [],
        },
    };
}

const sendMessageMutation = gql`
    mutation SendMessageMutation(
        $text: String
        $chatGroupId: String
        $botAction: String
        $skipNotifications: Boolean
        $metadata: Metadata
        $richContent: RichContentInputField
        $origin: OriginField
        $timeSpent: Int
    ) {
        sendMessage(
            text: $text
            chatGroupId: $chatGroupId
            botAction: $botAction
            skipNotifications: $skipNotifications
            metadata: $metadata
            richContent: $richContent
            origin: $origin
            timeSpent: $timeSpent
        ) {
            message {
                ...Message
            }
            botMessages {
                id
                text
                sender {
                    id
                    firstName
                    profilePhoto
                    accountRole
                }
                chatGroupId
                created
                attachment {
                    type
                    payload {
                        templateType
                        buttons {
                            type
                            style
                            title
                            payload
                            inline
                        }
                        text
                    }
                }
                input {
                    type
                    action
                    options
                    enabled
                    placeholder
                }
                instantAction
                visible
                read
                deleted
                isSenderBlocked
            }
        }
    }
    ${messageFragment}
`;

export default sendMessageMutation;
